import {Badge, Button, Table, TableColumnsType} from 'antd';
import ProTable from 'Components/ProTable';
import {DictListItem, getDictNode} from '../../service';
import useRequest from 'Utils/Hooks/useRequest';
import {DictManageMenu} from './Components/DictManageMenu';
import {Auth} from '../../../../../Features/Auth';

interface DictTableProps {
    dict: DictListItem;
    onEdit(dict: DictListItem, isChild: boolean): void;
    onAdd(): void;
    onDictChange(): void;
}

export function DictTable({dict, onEdit, onAdd, onDictChange}: DictTableProps) {
    const [data, {loading}, refresh] = useRequest(
        () => getDictNode(dict.code),
        {},
        [dict.code],
    );

    function onChange(isChild: boolean) {
        if (isChild) refresh();
        else onDictChange();
    }

    const dataSource: DictListItem[] = [
        {
            ...dict,
            children: data || [],
        },
    ];

    const columns: TableColumnsType<DictListItem> = [
        {title: '名称', dataIndex: 'name'},
        {title: '编码', dataIndex: 'code'},
        {title: '英文名称', dataIndex: 'nameEn'},
        {
            title: '启用状态',
            dataIndex: 'status',
            width: 100,
            render: (status: string) => (
                <Badge
                    status={status === '1' ? 'success' : 'default'}
                    text={status === '1' ? '已启用' : '已停用'}
                />
            ),
        },
        {title: '描述', dataIndex: 'remark'},
        {
            title: '操作',
            width: 250,
            align: 'center',
            fixed: 'right',
            render: (_, item) => (
                <ProTable.Operate>
                    <Auth code="SF_J476Zfxw15">
                        <Button type="link" onClick={onAdd}>
                            添加{item.children ? '子项' : '同级'}
                        </Button>
                    </Auth>

                    <Auth code="SF_J476Zfxw16">
                        <Button
                            type="link"
                            onClick={() => onEdit(item, !item.children)}>
                            编辑
                        </Button>
                    </Auth>

                    <DictManageMenu
                        data={item}
                        onChange={() => onChange(item.parentId !== '0')}
                    />
                </ProTable.Operate>
            ),
        },
    ];

    return (
        <Table
            rowKey="code"
            columns={columns}
            dataSource={dataSource}
            defaultExpandAllRows
            pagination={false}
            loading={loading}
            scroll={{x: 'max-content'}}
            sticky={{offsetHeader: -10}}
        />
    );
}
